import { createSlice } from '@reduxjs/toolkit';
import { getStoredTheme, setStoredTheme } from '../../utils/ThemeUtils';
import { ThemeState } from '../../types/theme.types';

const initialState: ThemeState = {
  theme: getStoredTheme()
};

const themeSlice = createSlice({
  name: 'theme',
  initialState,
  reducers: {
    toggleTheme: (state:any) => {
      const newTheme = state.theme === 'dark' ? 'light' : 'dark';
      state.theme = newTheme;
      setStoredTheme(newTheme);
    }
  }
});

export const { toggleTheme } = themeSlice.actions;
export default themeSlice.reducer;